//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SPage from "~/components/page/SPage.vue";
import Stepper from "~/components/zapis/Stepper.vue";
import ServiceModal from "~/components/service/ServiceModal.vue";
import BlockCertificateAdvertising from "~/components/sertifikaty/BlockCertificateAdvertising.vue";
import {CmsMetaMixin} from "~/node_modules/sitis-nuxt/lib/mixins/index";

// Этапы заполнения формы
import {AppMixin, UserMixin} from "~/node_modules/sitis-nuxt/lib/mixins";
import AgeSelection from "~/components/zapis/AgeSelection.vue";
import ServiceSelection from "~/components/zapis/ServiceSelection.vue";
import SalonSelection from "~/components/zapis/SalonSelection.vue";
import Form from "~/components/zapis/Form.vue";
import PopUpSelectionContactLenses from "~/components/zapis/PopUpSelectionContactLenses.vue";
import {atcb_action} from 'add-to-calendar-button';
import 'add-to-calendar-button/assets/css/atcb.css';

export default {
  name: 'ZapisIndex',

  components: {
    Form,
    SPage,
    Stepper,
    ServiceModal,
    AgeSelection,
    SalonSelection,
    ServiceSelection,
    PopUpSelectionContactLenses,
    BlockCertificateAdvertising
  },
  mixins: [AppMixin, CmsMetaMixin],

  async asyncData({$api, params, error, req}) {
    const host = req?.headers?.host || window?.location.host || '';
    if (String(host || '').includes('kazan.')) {
      error({ statusCode: 404, message: "Страница не найдена" });
      return {}
    }

    const {data: services} = await $api.agent.transport.get("services?expand=stores,image&dev=1");
    const {data: salons} = await $api.agent.transport.get("stores");

    return {
      salons,
      services,
      readServiceSlug: params?.slug || "",
    };
  },

  data() {
    return {
      salons: [],

      form: {
        age: "",
        service: "",
        salon: "",
        specialist: "",
        address: "",
      },
      sendedForm: {},
      breadcrumbs: [
        {
          title: "Главная",
          path: "/",
        },
        {
          title: "Запись на приём",
          path: "/zapis",
        },
      ],

      popUpSelectionContactLenses: {},

      readServiceSlug: "",
      hashSalon: "",

      stage: 0,
      permittedStage: 0,

      openModal: false,
      isAppointmentSended: false,
      isOpenPopUpSelectionContactLenses: false,

      uid: null,
      uuid: null,
    };
  },

  watch: {
    "$route.query": function () {
      this.initForm();
    },
  },

  mounted() {
    this.initUuid();
    this.initForm();

    let newForm = {...this.form};
    // Если салон выбран с главной страницы
    const salon = this.$route.hash?.split("#")?.[1] || "";
    if (Boolean(salon)) {
      newForm.salon = Number(salon);
      this.hashSalon = salon;
    }

    this.form = newForm;
  },

  computed: {
    salonServices: function () {
      const hash = this.hashSalon;

      if (!hash) {
        return this.services;
      }

      return this.services.filter((t) =>
        Boolean(t.stores.find((t) => String(t.id) === hash))
      );
    },
    salonAddressHash: function () {
      return (
        this.salons.find((t) => String(t.id) === this.hashSalon)?.address || ""
      );
    },

    messageSuccessAppointment: function () {
      const form = {...this.form};
      const sendedForm = {...this.sendedForm};
      const formSpecialist = this.sendedForm?.selectedSpecialist?.id || -1;

      if (
        !form.service ||
        form.service === -1 ||
        !form.salon ||
        form.salon === -1 ||
        !formSpecialist ||
        formSpecialist === -1
      ) {
        return `В ближайшее время с вами свяжется наш менеджер, чтобы подтвердить информацию и назначить удобное время посещения нашего специалиста`;
      }

      let ageMessage = "";
      if (form.age === "2-6") {
        ageMessage = "от 2 до 6 лет";
      }
      if (form.age === "7-11") {
        ageMessage = "от 7 до 11 лет";
      }
      if (form.age === "12-18") {
        ageMessage = "от 12 до 18 лет";
      }
      if (form.age === "19") {
        ageMessage = "старше 18 лет";
      }

      const serviceName = this.services.find((t) => t.id === sendedForm.service_id)?.name;
      const salon = this.salons.find((t) => t.id === sendedForm.store_id);
      const dateFormat = (sendedForm.date || "").split("-").reverse().join(".");
      const beginFormat = (sendedForm.begin || "")
        .split(":")
        .splice(0, 2)
        .join(":");
      const endFormat = (sendedForm.end || "")
        .split(":")
        .splice(0, 2)
        .join(":");

      return `
      Вы записаны на прием в салон "Очки для Вас"!</br>
      Услуга: <span class="text-primary">${serviceName}</span></br>
      Специалист: <span class="text-primary">${this.sendedForm?.selectedSpecialist?.name}</span></br>
      Дата, время: <span class="text-primary">${dateFormat} ${beginFormat}</span></br>
      Адрес: <span class="text-primary">${salon?.address || ""}</span></br>
      Услуга для возраста: <span class="text-primary">${ageMessage}</span></br>
      Рады будем вас видеть!
      `;
    },

    isShowCalendarButton: function () {
      return Boolean(process.env.isShowCalendarButton === 'true')
    },
    shopsList: function () {
      return this.$store.state["local-settings"].shopsList || []
    },
    cityIdFromStore: function () {
      const cityId = this.$store.state?.appState?.config?.city?.data?.id || null;
      if (!cityId) {
        // нет в городе
        return
      }
      return cityId
    },
    availibilityAppointmentToShop: function () {
      if (!this.cityIdFromStore) {
        return true
      }
      return this.shopsList.find((item) => item.city_id === this.cityIdFromStore)
    }
  },

  methods: {
    initUuid: function () {
      const searchParams = new URLSearchParams(window.location.search);

      let objectSearch = {};
      for (const [key, value] of searchParams) {
        objectSearch[key] = value;
      }

      if (!objectSearch?.uuid) {
        return;
      }

      this.uid = objectSearch?.uid;
      this.uuid = objectSearch?.uuid;

      const replaceUrl = [
        Boolean(objectSearch?.step_age) && `step_age=${ objectSearch?.step_age }`,
        Boolean(objectSearch?.step_service) && `step_service=${ objectSearch?.step_service }`,
        Boolean(objectSearch?.step_store) && `step_store=${ objectSearch?.step_store }`,
        Boolean(objectSearch?.step_specialist) && `step_specialist=${ objectSearch?.step_specialist }`,
      ].filter((t) => !!t).join('&');
      window.history.replaceState(
        null,
        null,
        `${this.$route.path}?${this.getSearchForLinkReplace(replaceUrl)}`
      );
    },

    addToCalendar() {
      const salon = this.salons.find((t) => t.id === this.sendedForm.store_id);
      const serviceName = this.services.find(
        (t) => t.id === this.sendedForm.service_id
      )?.name
        .replace(/\((.*?)\)/, '')
        .trim();

      atcb_action({
        name: `${serviceName} по адресу ${salon?.address || ""}`,
        description: `${this.sendedForm.comment}`,
        startDate: this.sendedForm.date,
        endDate: this.sendedForm.date,
        startTime: this.sendedForm.begin,
        endTime: this.sendedForm.end,
        options: ['Apple', 'Google', 'iCal', 'Microsoft365', 'Outlook.com', 'Yahoo'],
        timeZone: "Asia/Yekaterinburg",
        iCalFileName: "Reminder-Event",
        language: 'ru',
      })
    },
    disableInput() {
      this.$refs.input.setAttribute('disabled', 'disabled');
      this.$refs.input.classList.add('disabled-opacity');
    },
    initForm: function () {
      this.isAppointmentSended = false;

      let urlSearch = (window.location.search || "").substr(1).split("&");
      let replaceSearch = [];
      let step = 0;
      let permittedStage = 0;
      let newForm = {
        age: "",
        service: "",
        salon: Boolean(this.hashSalon) ? Number(this.hashSalon) : "",
        specialist: "",
        address: "",
      };

      // Проверяем, коректно ли заполнены данные
      urlSearch.map((item, idx) => {
        idx = idx;

        if (idx === 0 && item.indexOf("step_age") > -1) {
          step = 1;
          permittedStage = 1;
          newForm.age = (item || "").split("=")[1];

          replaceSearch.push(item);
        }
        if (idx === 1 && item.indexOf("step_service") > -1) {
          step = 2;
          permittedStage = 2;
          newForm.service = +(item || "").split("=")[1];

          replaceSearch.push(item);
        }
        if (idx === 2 && item.indexOf("step_store") > -1) {
          step = 3;
          permittedStage = 3;
          newForm.salon = +(item || "").split("=")[1];

          replaceSearch.push(item);
        }
        if (idx === 3 && item.indexOf("step_specialist") > -1) {
          step = 4;
          permittedStage = 4;
          newForm.specialist = +(item || "").split("=")[1];

          replaceSearch.push(item);
        }
      });
      if (this.uuid) {
        replaceSearch.push(`uuid=${ this.uuid }`)
      }

      this.stage = step;
      this.form = newForm;
      this.permittedStage = permittedStage;

      window.history.replaceState(
        null,
        null,
        `${this.$route.path}?${this.getSearchForLinkReplace(replaceSearch.join("&"))}`
      );
    },

    changeForm({name, value}, nextStage = null) {
      const newForm = {...this.form};
      newForm[name] = value;
      this.form = newForm;

      this.updateUrl();
      this.nextStage();

      window.scroll({
        top: 0,
        behavior: "smooth",
      });
    },
    changeStage(stage) {
      this.stage = stage;
      this.permittedStage = stage;

      if (this.stage == 0) {
        this.form = {};
      }
      if (this.stage == 1) {
        this.form.service = "";
        this.form.salon = "";
        this.form.salon = "";
      }
      if (this.stage == 2) {
        this.form.specialist = "";
        this.form.salon = "";
      }
      if (this.stage == 3) {
        this.form.specialist = "";
      }

      this.updateUrl();
    },

    nextStage() {
      let stage = 0;

      if (this.form.age) {
        stage = 1;
      }
      if (this.form.service) {
        stage = 2;
      }
      if (this.form.salon) {
        stage = 3;
      }

      this.stage = stage;
      this.permittedStage = stage;
    },
    updateUrl() {
      const routePath = this.$route.path;
      let urlSearch = [];

      if (this.form.age) {
        urlSearch.push(`step_age=${this.form.age}`);
      }
      if (this.form.service) {
        urlSearch.push(`step_service=${this.form.service}`);
      }
      if (this.form.salon) {
        urlSearch.push(`step_store=${this.form.salon}`);
      }

      urlSearch = urlSearch.join("&");

      this.$router.push(`${routePath}?${this.getSearchForLinkReplace(urlSearch)}`);
    },

    selectServiceModal: function (data) {
      const service = (this.salonServices || []).find((t) => String(t.id) === String(data.serviceId));
      if (service?.with_learning && !data.isConfirm) {
        let popUpSelectionContactLenses = {
          service: service,
          age: data.age
        };
        this.popUpSelectionContactLenses = popUpSelectionContactLenses;
        this.isOpenPopUpSelectionContactLenses = true;
        return null
      }
      this.form.age = data.age;
      this.changeForm({name: "service", value: data.serviceId}, 2);
    },
    selectPopUpSelectionContactLenses: function (data) {
      this.form.age = this.popUpSelectionContactLenses.age;
      this.changeForm({name: "service", value: data.id}, 2);

      this.popUpSelectionContactLenses = {};
      this.isOpenPopUpSelectionContactLenses = false;
    },

    onOpenServiceModal: function (slug) {
      this.readServiceSlug = slug;

      // Замена URL при открии стать
      window.history.replaceState(null, null, `/zapis/${slug}`);
    },
    onCloseServiceModal: function () {
      this.readServiceSlug = "";

      // Замена URL при открии стать
      window.history.replaceState(null, null, `/zapis`);
    },

    successSendedForm: function (props) {
      this.sendedForm = props;
      this.isAppointmentSended = true;
    },

    resetSalonHash: function () {
      this.hashSalon = "";

      let form = {...this.form}
      form.salon = ""
      this.form = form;
    },



    _parseSearchParams: function (searchString) {
      try {
        // Убираем знак '?' из начала строки
        const cleanSearch = searchString.startsWith('?') ? searchString.slice(1) : searchString;

        if (!cleanSearch) {
          return {};
        }

        // Разбиваем строку на пары ключ-значение
        const params = {};
        const pairs = cleanSearch.split('&');

        pairs.forEach(pair => {
          const [key, value] = pair.split('=');
          if (key) {
            // Декодируем URL-кодированные символы
            const decodedKey = decodeURIComponent(key);
            const decodedValue = value ? decodeURIComponent(value) : '';

            // Если значение выглядит как JSON, пытаемся его распарсить
            if (decodedValue.startsWith('{') || decodedValue.startsWith('[')) {
              try {
                params[decodedKey] = JSON.parse(decodedValue);
              } catch (e) {
                params[decodedKey] = decodedValue;
              }
            } else {
              params[decodedKey] = decodedValue;
            }
          }
        });

        return params;
      } catch (error) {
        console.error('Ошибка при парсинге параметров поиска:', error);
        return {};
      }
    },
    getSearchForLinkReplace: function (initLink) {
      const currentFullSearch = window.location.search || '';
      if (!currentFullSearch) {
        return initLink;
      }

      let objectCurrentSearch = this._parseSearchParams(currentFullSearch);
      ['step_age', 'step_service', 'step_store', 'step_specialist'].map((t) => {
        delete objectCurrentSearch[t];
      });

      let objectInitLink = this._parseSearchParams(initLink);

      let objectLink = {...objectInitLink, ...objectCurrentSearch};
      let stringLink = [];
      Object.keys(objectLink).map((key) => {
        stringLink.push(`${ key }=${ objectLink[key] }`);
      });
      return stringLink.filter((t) => !!t).join('&')
    }
  },
};
